export const PRESS = [
  {
    id: "post",
    outlet: "Post Gazetesi",
    date: "April 2019",
    type: "article",
    image: "/images/presse-post.jpg",
  },
  {
    id: "turkses",
    outlet: "TürkSes",
    date: "2018",
    type: "article",
    image: "/images/presse-turkses.png",
  },
  {
    id: "tidetv",
    outlet: "TIDE TV – Alev Show",
    date: "Radio-Interview: Psychologie, Hypnose & Business Coaching",
    type: "radio",
    link: "https://www.youtube.com/watch?v=sdHlH_FYJPg",
  },
];
